<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  mounted() {

  },
  methods: {
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #303030;
  height: 100%;
  overflow-x: hidden;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
html {
  height: 100%;
}

a {
  text-decoration: none;
}

.van-button--block.van-button--info {
  background-color: #2553E2 !important;
}

.van-dialog--round-button .van-dialog__confirm,
.van-dialog--round-button .van-dialog__cancel {
  border-radius: 999px !important;
  margin: 0 3px !important;
}

.van-dialog--round-button .van-dialog__cancel {
  border: 1px solid #a3a3a3 !important;
  color: #555555 !important;
}
</style>
